var _path, _circle, _path2, _circle2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoTeamMember2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 205,
    height: 152,
    viewBox: "0 0 205 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.4102 59.4726C89.1215 59.4726 99.1804 60.6982 107.681 58.2695",
    stroke: "#FB7C51",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 41.4971,
    cy: 16.2432,
    r: 14.7432,
    stroke: "#FB7C51",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 67.7457C4.04063 58.903 6.00766 49.9321 13.6471 44.0177C18.7532 40.0646 25.1302 39.8498 31.3346 39.8127C40.0417 39.7607 49.0114 39.254 57.6657 40.3467C66.2774 41.434 75.178 44.8701 78.3235 53.5289C80.4736 59.4477 80.9933 65.4318 80.9933 71.6503",
    stroke: "#FB7C51",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 105.838,
    cy: 34.2856,
    r: 23.3447,
    stroke: "#FB7C51",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4258 114.74C48.547 101.215 51.5557 87.4934 63.2405 78.4471C71.0506 72.4006 80.8045 72.0721 90.2944 72.0154C103.612 71.9359 117.332 71.1608 130.569 72.8321C143.741 74.4952 157.355 79.7509 162.166 92.9949C165.455 102.048 166.25 111.201 166.25 120.712",
    stroke: "#FB7C51",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M179.846 20.9072C179.846 28.7062 173.717 34.953 166.249 34.953C158.781 34.953 152.652 28.7062 152.652 20.9072C152.652 13.1081 158.781 6.86133 166.249 6.86133C173.717 6.86133 179.846 13.1081 179.846 20.9072Z",
    stroke: "#FB7C51",
    strokeWidth: 3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M129.54 70.1967C131.437 61.7337 133.265 53.1479 140.365 47.4874C145.111 43.704 151.038 43.4984 156.805 43.463C164.897 43.4132 173.234 42.9282 181.278 43.974C189.281 45.0147 197.554 48.3033 200.477 56.5903C202.476 62.255 202.959 67.9822 202.959 73.9337",
    stroke: "#FB7C51",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1797 126.318C18.6673 124.12 23.7901 124.499 28.6763 124.463C42.9882 124.357 57.3105 124.446 71.6165 124.875C108.747 125.987 145.881 126.99 182.986 128.791",
    stroke: "#FB7C51",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.72776 79.2383C2.71114 84.8297 3.12071 90.5714 2.98926 96.2239",
    stroke: "#FB7C51",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M130.997 149.223C152.855 149.223 178.094 152.298 199.422 146.205",
    stroke: "#FB7C51",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M86.4482 76.2095C92.3529 80.4187 98.1301 84.7964 103.907 89.1787",
    stroke: "#FB7C51",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M124.856 76.2095C121.265 77.2027 118.896 79.1912 116.542 81.9736C114.972 83.8288 112.904 85.0339 111.166 86.6846C109.751 88.029 108.304 89.2693 106.898 90.6751",
    stroke: "#FB7C51",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M106.898 90.6758C108.931 102.043 108.357 113.207 109.393 124.595",
    stroke: "#FB7C51",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M115.962 100.61C115.817 99.4536 114.949 100.984 115.224 101.609C115.438 102.094 115.907 102.334 116.177 101.778C116.279 101.568 115.784 100.352 115.685 100.057",
    stroke: "#FB7C51",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M117.068 117.614C117.055 117.12 116.674 116.692 116.799 117.253C116.821 117.352 116.987 117.361 117.068 117.337C117.294 117.27 117.206 116.635 117.206 116.469C117.206 116.13 117.203 115.825 116.853 116.231C116.691 116.419 116.515 117.261 116.515 117.199",
    stroke: "#FB7C51",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoTeamMember2);
export default __webpack_public_path__ + "static/media/noTeamMember2.b8383f575c34613b5ec9cccca2fb9cb2.svg";
export { ForwardRef as ReactComponent };